import { Suspense, useEffect } from "react";
import "./App.scss";
import "translation";
import { BrowserRouter } from "react-router-dom";
import Routes from "Routes";
import { Amplify } from "aws-amplify";
import * as Sentry from "@sentry/react";
import { poolData } from "shared/components/user-pool/AwsConfig";
import { useDispatch, useSelector } from "react-redux";
import { getLoggedUser } from "explorer/reducers/users";
import { autenticado } from "shared/helpers/auth-functions";
import { loadUserId } from "shared/helpers/browser-id";
import { getCountries } from "explorer/reducers/countries";
import GoogleTag from "shared/components/google-tag";
import Personify from "shared/components/personify/Personify";
import { ToastContainer } from "react-toastify";
import {
  getLoggedUserArtist,
  getUserDistroToken,
} from "explorer/reducers/artistas";
import { getGeneros } from "explorer/reducers/generos";
import { getStrmClassVideos } from "explorer/reducers/strm-class";
import { LayoutProvider } from "shared/layout/LayoutProvider";
import { getMonitoredData } from "explorer/reducers/monitored-data";
import { useLDClient } from "launchdarkly-react-client-sdk";
import { UserState } from "explorer/reducers/users";
import { getUserSubscription } from "explorer/reducers/subscription";

// import * as rdd from "react-device-detect";

// (rdd as any).isMobile = true;
// (rdd as any).isDesktop = false;

Amplify.configure(poolData);
loadUserId();

const {
  REACT_APP_SENTRY_DSN,
  REACT_APP_SENTRY_SAMPLE_RATE,
  REACT_APP_SENTRY_ENVIORNMENT,
} = process.env;

Sentry.init({
  dsn: REACT_APP_SENTRY_DSN,
  integrations: [
    new Sentry.Integrations.Breadcrumbs({
      console: false,
    }),
    new Sentry.Replay({
      maskAllText: false,
      blockAllMedia: true,
    }),
  ],
  environment: REACT_APP_SENTRY_ENVIORNMENT,
  tracesSampleRate: Number(REACT_APP_SENTRY_SAMPLE_RATE || 1.0),
});

function App() {
  const ldClient = useLDClient();
  const dispatch = useDispatch();
  const { loggedUser } = useSelector((state: UserState) => state.users);

  useEffect(() => {
    if (ldClient && loggedUser.login && loggedUser.id) {
      const artist = loggedUser.userArtists?.[0];
      ldClient.identify({
        kind: "user",
        key: loggedUser.id.toString(),
        email: loggedUser.login,
        typeUser: loggedUser.typeAccess,
        earlyAdopter: loggedUser.earlyAdopterAccess,
        loggedUserCreatedOn: loggedUser.createdOn
          ? new Date(loggedUser.createdOn).getTime()
          : undefined,
        artistId: artist?.id?.toString(),
        artistName: artist?.name,
        artistCountry: artist?.countryCode,
        artistLevel: artist?.lastStage,
        artistGenres: artist?.genreCodes,
        artistCashAdvanceAvailable: artist?.cashAdvanceAvailable,
        artistCashAdvanceTotalEstimated: artist?.cashAdvanceTotalEstimated,
        artistCashAdvanceTotalEstimatedCurrency:
          artist?.cashAdvanceTotalEstimatedCurrency,
      });
    }
  }, [
    ldClient,
    loggedUser.createdOn,
    loggedUser.earlyAdopterAccess,
    loggedUser.id,
    loggedUser.login,
    loggedUser.typeAccess,
    loggedUser.userArtists,
  ]);

  useEffect(() => {
    if (autenticado()) {
      dispatch(getLoggedUser());
      dispatch(getLoggedUserArtist());
      dispatch(getStrmClassVideos());
      dispatch(getMonitoredData());
      dispatch(getUserDistroToken());
      dispatch(getUserSubscription());
    }
    dispatch(getGeneros());
    dispatch(getCountries());
  }, [dispatch]);

  return (
    <Suspense fallback="loading">
      <LayoutProvider>
        <BrowserRouter>
          <ToastContainer theme="dark" style={{ zIndex: 9999999 }} />
          <Personify />
          <GoogleTag />
          <Routes />
        </BrowserRouter>
      </LayoutProvider>
    </Suspense>
  );
}

export default App;
